// extracted by mini-css-extract-plugin
export default {"notice":"notice___htNnI","noticeContent":"noticeContent___x6TAW"};